import { useState, useEffect } from 'react';

interface HeaderProps {
  onOpenForm: () => void;
}

export default function Header({ onOpenForm }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-[#0d1117] ${
        scrolled ? 'shadow-lg shadow-black/40 border-b border-white/5' : ''
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center cursor-pointer">
          <img
            src="https://99-marketing.com/wp-content/uploads/2024/03/99_logo-3.png"
            alt="99 Marketing"
            className="h-9 md:h-11 w-auto object-contain"
          />
        </a>

        {/* Right side — phone + prominent CTA */}
        <div className="flex items-center gap-3 md:gap-5">
          <a
            href="tel:8004559670"
            className="hidden md:flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white transition-colors duration-200 cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-emerald-400" style={{ fontSize: '15px' }}></i>
            </span>
            800-455-9670
          </a>

          {/* Prominent CTA */}
          <button
            onClick={onOpenForm}
            className="whitespace-nowrap relative group flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-sm md:text-base font-bold px-5 md:px-7 py-2.5 md:py-3 rounded-full cursor-pointer overflow-hidden transition-all duration-200 hover:scale-[1.03] hover:shadow-lg hover:shadow-emerald-500/40"
          >
            {/* Glow pulse ring */}
            <span className="absolute inset-0 rounded-full bg-emerald-400/20 animate-ping opacity-60 group-hover:opacity-0 transition-opacity duration-300"></span>
            <span className="relative flex items-center gap-2">
              <i className="ri-eye-line" style={{ fontSize: '16px' }}></i>
              <span className="hidden sm:inline">Get Free Website Preview</span>
              <span className="sm:hidden">Free Preview</span>
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
